export const desktopWidth = '80%'
export const mobileWidth = '100%'
export const blockPadding = '30px'

export const appStoreLink = 'https://apps.apple.com/app/id326839545'
export const googlePlayLink =
  'https://play.google.com/store/apps/details?id=ru.mamba.client'
export const appGalleryLink = 'https://appgallery.huawei.com/app/C100670477'

export const vkLink = 'https://vk.com/mambadate'
export const telegramLink = 'https://t.me/mambadate'
